import { Component, OnInit, HostListener, afterNextRender } from "@angular/core"; import { Location } from "@angular/common";
import { FilterMatchMode, FilterService, PrimeNGConfig } from 'primeng/api';
import { interval, Subscription } from 'rxjs';
import { DonneesBaseService } from './services/donnees-base-service';
import { SupabaseService } from "./services/supabase.service";
import { UserGeneratedTextDisplayService } from './services/user-generated-text-display.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  menuMode = 'static';

  colorScheme = 'light';

  menuTheme = 'layout-sidebar-darkgray';

  inputStyle = 'outlined';

  ripple: boolean;

  constructor(
    public sdb: DonneesBaseService,
    private primengConfig: PrimeNGConfig,
    public supabaseService: SupabaseService,
    public filterService: FilterService,
    private userGeneratedTextDisplayService: UserGeneratedTextDisplayService) {
    afterNextRender(() => {
      this.userGeneratedTextDisplayService.attach(document.body);
    });
  }

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.primengConfig.filterMatchModeOptions = {
      text: [
        FilterMatchMode.CONTAINS,
        FilterMatchMode.STARTS_WITH,
        FilterMatchMode.ENDS_WITH,
        FilterMatchMode.EQUALS,
        FilterMatchMode.NOT_EQUALS,
        FilterMatchMode.NOT_CONTAINS,
      ],
      numeric: [
        FilterMatchMode.EQUALS,
        FilterMatchMode.NOT_EQUALS,
        FilterMatchMode.LESS_THAN,
        FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
        FilterMatchMode.GREATER_THAN,
        FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
      ],
      date: [
        FilterMatchMode.DATE_IS,
        FilterMatchMode.DATE_IS_NOT,
        FilterMatchMode.DATE_BEFORE,
        FilterMatchMode.DATE_AFTER,
      ],
    };
    this.primengConfig.setTranslation({
      startsWith: "Commence par",
      contains: "Contient",
      notContains: "Ne contient pas",
      endsWith: "Se termine par", 
      equals: "Égal à",
      notEquals: "Différent de",
      noFilter: "Pas de filtre",
      lt: "Inférieur à",
      lte: "Inférieur ou égal à",
      gt: "Supérieur à", 
      gte: "Supérieur ou égal à",
      dateIs: "Date est",
      dateIsNot: "Date n'est pas",
      dateBefore: "Date avant",
      dateAfter: "Date après",
      clear: "Effacer",
      apply: "Appliquer",
      matchAll: "Correspond à tous",
      matchAny: "Correspond à un",
      addRule: "Ajouter une règle",
      removeRule: "Supprimer la règle",
      accept: "Oui",
      reject: "Non",
      choose: "Choisir",
      upload: "Téléverser",
      cancel: "Annuler",
      pending: "En attente",
      fileSizeTypes: ['o', 'Ko', 'Mo', 'Go', 'To', 'Po', 'Eo', 'Zo', 'Yo'],
      dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
      dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
      dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
      monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
      monthNamesShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
      chooseYear: "Choisir l'année",
      chooseMonth: "Choisir le mois",
      chooseDate: "Choisir la date",
      prevDecade: "Décennie précédente",
      nextDecade: "Décennie suivante", 
      prevYear: "Année précédente",
      nextYear: "Année suivante",
      prevMonth: "Mois précédent",
      nextMonth: "Mois suivant",
      prevHour: "Heure précédente",
      nextHour: "Heure suivante",
      prevMinute: "Minute précédente",
      nextMinute: "Minute suivante",
      prevSecond: "Seconde précédente",
      nextSecond: "Seconde suivante",
      am: "am",
      pm: "pm",
      today: "Aujourd'hui",
      weekHeader: "Sem",
      dateFormat: "dd/mm/yy",
      weak: "Faible",
      medium: "Moyen",
      strong: "Fort",
      passwordPrompt: "Entrez un mot de passe",
      emptyFilterMessage: "Aucun résultat trouvé",
      searchMessage: "{0} résultats disponibles",
      selectionMessage: "{0} éléments sélectionnés",
      emptySelectionMessage: "Aucun élément sélectionné",
      emptySearchMessage: "Aucun résultat trouvé",
      emptyMessage: "Aucune option disponible",
    });
}

ngOnDestroy() {
  /* this.subscription.unsubscribe(); */
}
}
